'use client';
import { use } from 'react';
import AppLayout from '@/components/AppLayout';
import SupplierProfileContent from './components/SupplierProfileContent';

export default function SupplierProfilePage({ params }: { params: Promise<{ id: string }> }) {
  const { id } = use(params);
  return (
    <AppLayout>
      <SupplierProfileContent id={id} />
    </AppLayout>
  );
}
